/**
 * FAQ Accordion functionality
 */
 projectFunctions.faqAccordionFunctions = projectFunctions.faqAccordionFunctions || {};

 /**
  * Init: Will be triggered on document ready.
  */
 projectFunctions.faqAccordionFunctions.init = function() {
     this.faqAccordion();
 };
 
 projectFunctions.faqAccordionFunctions.faqAccordion = function () {
  $('.custom-single-post__faq-item-title').on('click', function() {
    const $clickedItem = $(this).closest('.custom-single-post__faq-item');
    const isActive = $clickedItem.hasClass('active');
    
    // Remove active class from all items
    $('.custom-single-post__faq-item').removeClass('active');
    
    // If clicked item wasn't active, add active class to it
    if (!isActive) {
      $clickedItem.addClass('active');
    }
  });
};

